import PropTypes from 'prop-types'
import React, { useState } from 'react'
import styled from 'styled-components'
import { Input, InputWrapper } from 'components/Input'
import { COLOR, FONT_WEIGHT } from 'Theme'

const INVALID_CHARACTERS = ['.', '-', '+', 'e']

const CustomInput = styled(Input)`
  ${InputWrapper} {
    border: none;
    justify-content: center;
    background-color: transparent;

    ${({ isFocused, isError, isWarning, isDisabled }) =>
      !isFocused &&
      !isError &&
      !isWarning &&
      !isDisabled &&
      `
      border: none;
      &:hover {
        border: none;
      }
    `}

    &::before {
      content: '$';
      display: ${({ isWithCurrencySymbol }) =>
        isWithCurrencySymbol ? 'block' : 'none'};
      color: ${COLOR.PRIMARY_1};
      font-weight: ${FONT_WEIGHT.MEDIUM};
    }

    input {
      width: ${({ isWithCurrencySymbol, inputSize }) =>
        isWithCurrencySymbol ? `${inputSize}ch` : '100%'};
      color: ${COLOR.PRIMARY_1};
      font-weight: ${FONT_WEIGHT.MEDIUM};
      text-align: center;
    }
  }
`

export const CardSelectItemInput = ({ maxLength = 255, ...rest }) => {
  const [inputValue, setInputValue] = useState('')

  return (
    <CustomInput
      {...rest}
      value={inputValue}
      onKeyDown={(event) => {
        /**
         * Workaround for https://stackoverflow.com/questions/64920999/event-target-value-becomes-empty-string-in-inputtype-number-upon-entering-a-do
         * This issue occurs in Chrome
         *
         * Input type number returns value only if it is valid int or float
         * When number without decimal values but with dot is entered,
         * the value of the input is empty string.
         */
        if (INVALID_CHARACTERS.includes(event.key)) {
          event.preventDefault()
        }
      }}
      isWithCurrencySymbol={!!inputValue}
      inputSize={inputValue.length}
      onChange={({ target: { value } }) => {
        setInputValue((prevState) =>
          value.length <= maxLength ? value : prevState
        )
      }}
    />
  )
}

CardSelectItemInput.propTypes = {
  maxLength: PropTypes.number,
}
